import { Tooltip } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectFinancialsContractType } from 'api/project';
import { ProjectFinancialsContext } from 'contexts/project-financials';
import { useProjectFinancialsWidgets } from '../../hooks/widgets';
import {
  DataCardTitleWrapper,
  GaugeChartContainer,
  HiddenInfo,
  RowWrapper,
} from '../common';
import { FinancialsDataCard } from '../data-card';
import { ProjectFinancialsCardEmptyState } from '../empty-state';
import { FinancialsMiniCard } from '../mini-card';
import { FinancialStatsGrid } from '../stats-grid';

export const ProjectFinancialsWidgets: FC = () => {
  const context = useContext(ProjectFinancialsContext);
  const {
    projectFinancials: {
      projectFinancialDetails: { financialContractType },
    },
  } = context;

  const {
    budgetWidgetData,
    hoursWidgetData,
    budgetWidgetTooltipContent,
    nonBillableStats,
  } = useProjectFinancialsWidgets();

  const { stats: budgetStats, chartOptions: budgetChartOptions } =
    budgetWidgetData;

  const { stats: hoursStats, chartOptions: hoursChartOptions } =
    hoursWidgetData;

  return (
    <RowWrapper>
      {financialContractType === ProjectFinancialsContractType.NONBILLABLE ? (
        <>
          {nonBillableStats.map((stat) => (
            <FinancialsMiniCard stat={stat} />
          ))}
        </>
      ) : (
        <>
          <FinancialsDataCard
            primary={
              <DataCardTitleWrapper>
                <FormattedMessage
                  id={`project.financials.${financialContractType}.widget.budget.title`}
                />
              </DataCardTitleWrapper>
            }
            content={
              budgetChartOptions == null ? (
                <ProjectFinancialsCardEmptyState />
              ) : (
                <GaugeChartContainer>
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={budgetChartOptions}
                  />
                </GaugeChartContainer>
              )
            }
            secondary={
              budgetWidgetTooltipContent && (
                <Tooltip
                  title={budgetWidgetTooltipContent}
                  overlayStyle={{ maxWidth: 'unset' }}
                  placement="rightTop"
                >
                  <HiddenInfo>
                    <FormattedMessage
                      id={`project.financials.${financialContractType}.legend.info`}
                    />
                  </HiddenInfo>
                </Tooltip>
              )
            }
            extraInfo={
              budgetStats.length > 0 ? (
                <FinancialStatsGrid stats={budgetStats} />
              ) : null
            }
          />
          <FinancialsDataCard
            primary={
              <DataCardTitleWrapper>
                <FormattedMessage
                  id={`project.financials.${financialContractType}.widget.hours.title`}
                />
              </DataCardTitleWrapper>
            }
            content={
              hoursChartOptions == null ? (
                <ProjectFinancialsCardEmptyState />
              ) : (
                <GaugeChartContainer>
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={hoursChartOptions}
                  />
                </GaugeChartContainer>
              )
            }
            extraInfo={
              hoursStats.length > 0 ? (
                <FinancialStatsGrid stats={hoursStats} />
              ) : null
            }
          />
        </>
      )}
    </RowWrapper>
  );
};
